import Vue from 'vue';
import store from '@/store';

export const aiAccess = Vue.observable({ allowed: false, ready: false, error: '' });
let pending = null;
let sessionKey = '';

export function refreshAiAccess() {
  const token = store.state.sToken;
  const key = [token, store.state.sUserId, store.state.sEnterpriseId].join(':');
  if (key !== sessionKey) {
    sessionKey = key;
    pending = null;
    aiAccess.allowed = false;
    aiAccess.ready = false;
  }
  if (!token || store.state.bEmbedSession) {
    aiAccess.allowed = false;
    aiAccess.ready = false;
    return Promise.resolve(false);
  }
  if (pending) return pending;
  const request = (async () => {
    try {
      const response = await DB.get(`${URI}/api/v1/${store.state.language || 'en'}/billing/ai-access`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (key !== sessionKey) return false;
      if (typeof response.data?.access?.allowed !== 'boolean') throw new Error('Invalid access response');
      aiAccess.allowed = response.data.access.allowed;
      aiAccess.ready = true;
      aiAccess.error = '';
      return aiAccess.allowed;
    } catch (error) {
      if (key === sessionKey) {
        aiAccess.allowed = false;
        aiAccess.ready = false;
        aiAccess.error = 'No pudimos verificar tu acceso a Fresher AI. Intenta nuevamente.';
      }
      return false;
    } finally {
      if (key === sessionKey) pending = null;
    }
  })();
  pending = request;
  return request;
}
